import { Ticket } from '@ui/uikit/components/icons/mono';

type TicketsListSkeletonProps = {
  title?: string;
};

export const TicketsListSkeleton = ({ title }: TicketsListSkeletonProps) => {
  return (
    <div className="flex flex-col gap-1.5">
      {title ? <div className="text-caption-sm-strong-a text-base-text-primary">{title}</div> : ''}
      <div className="flex gap-2 items-center py-2">
        <Ticket className="text-base-text-quaternary icon-xs" />
        <div className="skeleton-text h-3 w-[80px]"></div>
      </div>
    </div>
  );
};
